import { render } from "./OpennessOrganizationCategoriesList.vue?vue&type=template&id=ca5f236a&scoped=true"
import script from "./OpennessOrganizationCategoriesList.vue?vue&type=script&lang=js"
export * from "./OpennessOrganizationCategoriesList.vue?vue&type=script&lang=js"

import "./OpennessOrganizationCategoriesList.vue?vue&type=style&index=0&id=ca5f236a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5f236a"]])

export default __exports__